import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { billAmountThreshold } from '../../../constants'
import { useInvoices } from '../../../hooks/useInvoices'
import { InvoiceList } from './InvoiceList'

export const UnpaidInvoices = () => {
	const { t } = useTranslation('pages_invoices')

	const { invoices } = useInvoices()

	const totalUnpaid = useMemo(() => {
		return invoices.unpaid.reduce((sum, invoice) => sum + invoice.Balance, 0)
	}, [invoices.unpaid])

	return (
		<div>
			{invoices.unpaid.length > 0 && (
				<div className='summary'>
					<h2 className='text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
						{t('unpaid')}
					</h2>
					<span className='money text-brand-primary-100-light dark:text-brand-secondary-100-dark'>
						{totalUnpaid.toFixed(2)}
						<span className='currency text-text-grey-200 dark:text-text-grey-100'> €</span>
					</span>
				</div>
			)}
			<InvoiceList invoices={invoices.unpaid} />

			{invoices.unpaid.length === 0 && (
				<div className='no-invoices'>
					<span className='bold dark:text-white'>{t('eiUusia')}</span>
					<span className='dark:text-text-grey-100'>
						{t('lahetammeLaskun', { amount: `${billAmountThreshold}` })}
					</span>
					<span className='dark:text-text-grey-100'>{t('laskuKuukaudenAlussa')}</span>
				</div>
			)}
			<div className='w-3/5 mx-auto mt-6'>
				<span className='disclaimer text-text-grey-200 dark:text-text-grey-100 text-center block'>
					{t('disclaimer')}
				</span>
			</div>
		</div>
	)
}
